import { FaArrowRight, FaEnvelope, FaGithub, FaLinkedinIn } from "react-icons/fa";
import { profile } from "../data";

function CallToAction() {
  return (
    <section className="container" id="contact">
      <div className="cta">
        <span className="mono">Contact</span>
        <h2>
          Let's build <em>something.</em>
        </h2>
        <p>
          I'm looking for a 6-month end-of-studies internship (PFE) in Java/Spring
          backend &amp; DevOps starting January 2027.
        </p>

        <a href={`mailto:${profile.email}`} className="cta-email">
          {profile.email} <FaArrowRight />
        </a>

        <div className="cta-social">
          <a href={`mailto:${profile.email}`} aria-label="Email" title={profile.email}>
            <FaEnvelope />
          </a>
          <a href={profile.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
          <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
